module.exports = __webpack_public_path__ + "img/Group 427320767@2x.89b562e3.png";